<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <b-card class="mb-0">
        <b-link class="brand-logo">
           <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
            width="250"
          />
        </b-link>

        <b-card-title>
          Verifikasi OTP
        </b-card-title>
        <p>Silahkan masukkan Kode OTP yang dikirimkan ke Alamat Email, untuk mengaktifkan Akun Anda</p>

        <!-- form -->
        <validation-observer
          ref="verifikasiForm"
          #default="{invalid}"
        >
          <div v-if="timer > 0">
            <b-form
              class="auth-verifikasi-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label-for="otp"
                label="Kode OTP"
              >
                <validation-provider
                  #default="{ errors }"
                  name="OTP"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="otp"
                    v-model="otp"
                    name="otp"
                    :state="errors.length > 0 ? false:null"
                    placeholder=""
                    autofocus
                    type="number"
                  />
                <small class="text-danger">{{ errors[0] ? 'Silahkan isi Kode OTP anda' : '' }}</small>
                </validation-provider>
              </b-form-group>
              <!-- submit button -->
              <b-button
                variant="primary"
                type="submit"
                block
                :disabled="loading == 1"
                @click="submitOTP()"
              >
                <div v-if="loading == 0">
                  Verifikasi
                </div>
                <div v-if="loading == 1">
                  <b-spinner label="Spinning"></b-spinner>
                </div>
              </b-button>
              <b-card-text class="text-center mt-2">
                <span>Waktu: {{ timer }} detik</span>
              </b-card-text>
            </b-form>
          </div>
          <div v-else>
            <b-card-text class="text-center mt-2">
              <span>Waktu habis. Klik tombol kirim ulang OTP untuk mendapatkan OTP baru.</span>
              <b-form
                class="auth-verifikasi-form mt-2"
                @submit.prevent
              >
                <b-button 
                  variant="primary" 
                  type="submit"
                  block @click="resendOTP"
                >
                  
                  <div v-if="loading == 0">
                    Kirim Ulang OTP
                  </div>
                  <div v-if="loading == 1">
                    <b-spinner label="Spinning"></b-spinner>
                  </div>
                </b-button>
              </b-form>
            </b-card-text>
          </div>
        </validation-observer>
        <b-card-text class="text-center mt-2">
          <span>Sudah Verifikasi? </span>
          <b-link :to="{ name: 'auth-login' }">
            <span>Login di sini</span>
          </b-link>
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend, BFormCheckbox, BImg, BSpinner,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import router from '@/router'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  postVerify,
  postResend,
} from '@/connection-api/master'
import {
  resetAkun,
} from '@/connection-api/master'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BImg,
    vSelect,
    BSpinner,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loading: 0,
      loadingShow: false,
      reset: {},
      required,
      otp: "",
      timer: 120, // 5 menit dalam detik
      timerInterval: null,
      sideImg: require('@/assets/images/logo/logo.png'),
    }
  },
  mounted() {
    this.startTimer();
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/logo.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    submitOTP() {
      this.loading = 1
      const email = router.currentRoute.params.email;
      var data = {
        email: email,
        token: this.otp,
      }
      postVerify(data)
        .then(response => {
          if (response.data.status?.code === '00') {
            this.makeToast('success', response.data.status?.message)
            setTimeout(() => {
              this.loading = 0
              this.$router.push({ name: 'auth-login' })
            }, 3000);
          } else {
            this.loading = 0
            this.makeToast('danger', response.data.status?.message)
          }
        })
        .catch(error => console.log(error));
      // Implementasikan logika untuk memeriksa OTP
      // Jika benar, lakukan aksi yang sesuai
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Verifikasi OTP',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    resendOTP() {
      // Implementasikan logika untuk mengirim ulang OTP
      this.loading = 1
      const email = router.currentRoute.params.email;
      this.timer = 300;
      this.startTimer();
      var data = {
        email: email
      }
      postResend(data)
        .then(response => {
          if (response.data.status?.code === '00') {
            this.loading = 0
            this.makeToast('success', 'Kode OTP sudah dikirimkan, silahkan cek Email.')
          } else {
            this.loading = 0
            this.makeToast('danger', response.data.status?.message)
          }
        })
        .catch(error => console.log(error));
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
